import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import ModelGroups from "components/Wizard/RightPanel/ModelGroups";

import * as globalReducer from "containers/App/reducer";
import * as runReducer from "containers/Run/reducer";
import * as wizardReducer from "containers/Wizard/reducer";
import * as oldProjectReducer from "containers/OldProject/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as homeReducer from "containers/Home/reducer";
import * as deploymentsReducer from "containers/Deployments/reducer";
import * as modelGroupReducer from "containers/ModelGroup/reducer";

import { isEnabled } from "utils/featureFlags";
import { getIsModelSplits } from "containers/ModelGroup/reducer";

class ModelGroupsContainer extends React.PureComponent {
  render() {
    return <ModelGroups {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updatePanelMode: (panelMode, id = ownProps.originalId) =>
      dispatch(runReducer.updatePanelMode(id, ownProps.blueprintId, panelMode)),
    updateMode: (mode) => dispatch(runReducer.updateMode(ownProps.originalId, mode)),

    updateStep: (step) => dispatch(oldProjectReducer.updateStep(step)),
    scrollToStep: (step) => dispatch(wizardReducer.scrollToStep(step)),
    scrollToDataset: () => wizardReducer.scrollToDataset(),

    updateSpecialIndex: (specialIndex) => dispatch(runReducer.updateSpecialIndex(ownProps.originalId, specialIndex)),
    createSetupFromSpecial: (specialVals) =>
      dispatch(setupReducer.createSetupFromSpecial(ownProps.originalId, specialVals)),
    updateRelatedId: (relatedId, skipSetup) =>
      dispatch(runReducer.updateRelatedId(ownProps.originalId, relatedId, skipSetup)),

    createModelGroup: () => dispatch(modelGroupReducer.createModelGroup(ownProps.originalId)),
    deleteModelGroup: (modelGroupId) => dispatch(modelGroupReducer.deleteModelGroup(ownProps.originalId, modelGroupId)),
    deleteSubModelGroup: (subModelGroupId) =>
      dispatch(modelGroupReducer.deleteSubModelGroup(ownProps.originalId, subModelGroupId)),
    linkModelToGroup: (specialVals) => dispatch(modelGroupReducer.linkModelToGroup(ownProps.originalId, specialVals)),
    updatePriority: (specialId, priortyDelta) =>
      dispatch(modelGroupReducer.updatePriority(ownProps.originalId, specialId, priortyDelta)),
    updateModelGroupIsLoading: (isLoading) => modelGroupReducer.updateIsLoading(ownProps.originalId, isLoading),

    updateDeployedModel: (subGroupIndex, model) =>
      dispatch(modelGroupReducer.updateDeployedModel(ownProps.originalId, subGroupIndex, model)),

    deployModelGroup: () => dispatch(deploymentsReducer.deployModelGroup(ownProps.originalId))
  };
};

const mapStateToProps = (state, ownProps) => {
  const datasetId = runReducer.getJob(state, ownProps.originalId).datasetId;
  return {
    modelGroup: modelGroupReducer.getModelGroup(state, ownProps.originalId),
    headModel: modelGroupReducer.getHeadModel(state, ownProps.originalId),
    linkedModels: modelGroupReducer.getLinkedModels(state, ownProps.originalId),

    specialOptions: homeReducer.getSpecialOptions(state, datasetId),
    specialIndex: runReducer.getSpecialIndex(state, ownProps.originalId),

    isModelSplits: getIsModelSplits(),
    isModelGroupsLoading: globalReducer.getIsModelGroupsLoading(state),
    modelGroupDeploy: deploymentsReducer.getModelGroupDeploy(state, ownProps.originalId),

    mode: runReducer.getMode(state, ownProps.originalId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ModelGroupsContainer);
